import React from 'react';
import { Box, Select, MenuItem, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import LanguageIcon from '@mui/icons-material/Language';

const LanguageSelector = ({ variant = 'default' }) => {
  const { i18n } = useTranslation();

  const handleLanguageChange = (event) => {
    const newLang = event.target.value;
    i18n.changeLanguage(newLang);
    localStorage.setItem('i18nextLng', newLang);
  };

  const styles = {
    default: {
      wrapper: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
      },
      icon: {
        mr: 1,
        color: 'inherit'
      },
      select: {
        color: 'inherit',
        '.MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(0,0,0,0.23)' },
        '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(0,0,0,0.87)' },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: 'primary.main' },
        '.MuiSvgIcon-root': { color: 'inherit' },
        width: '100%',
        minWidth: '120px'
      }
    },
    header: {
      wrapper: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
      },
      icon: {
        mr: 1,
        color: 'white'
      },
      select: {
        color: 'white',
        backgroundColor: 'rgba(255,255,255,0.1)',
        '.MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255,255,255,0.5)' },
        '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255,255,255,0.8)' },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: 'white' },
        '.MuiSvgIcon-root': { color: 'white' },
        width: '100%',
        minWidth: '120px'
      }
    },
    sidebar: {
      wrapper: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        px: 2,
        py: 1,
      },
      icon: {
        mr: 1,
        color: 'text.secondary'
      },
      select: {
        color: 'text.primary',
        '.MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(0,0,0,0.12)' },
        '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(0,0,0,0.87)' },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: 'primary.main' },
        '.MuiSvgIcon-root': { color: 'inherit' },
        width: '100%',
        minWidth: '120px'
      }
    }
  };

  const currentStyle = styles[variant];

  return (
    <Box sx={currentStyle.wrapper}>
      <LanguageIcon sx={currentStyle.icon} />
      <Select
        value={i18n.language}
        onChange={handleLanguageChange}
        size="small"
        sx={currentStyle.select}
        MenuProps={{
          PaperProps: {
            sx: {
              backgroundColor: variant === 'header' ? 'rgba(0,0,0,0.9)' : 'background.paper',
              '& .MuiMenuItem-root': {
                color: variant === 'header' ? 'white' : 'inherit'
              }
            }
          }
        }}
      >
        <MenuItem value="en">
          <Typography>English</Typography>
        </MenuItem>
        <MenuItem value="pt">
          <Typography>Português</Typography>
        </MenuItem>
        <MenuItem value="es">
          <Typography>Español</Typography>
        </MenuItem>
      </Select>
    </Box>
  );
};

export default LanguageSelector;
